import {useQuery} from "@tanstack/react-query";
import {pubApi} from "../services/pubService";

export const usePubsQuery = () => {
  const {data, isLoading, isError, error} = useQuery({
    queryKey: ["pub"],
    queryFn: () =>
      pubApi.getAll({page: 0, size: 10, order: [["order", "ASC"]]}),
    select: (response) => {
      return response.rows;
    },
  });
  return {
    data,
    isLoading,
    isError,
    error,
  };
};
